import { useState, useCallback } from 'react';

import { useElementEvent } from './use-element-event';

export function useClickOnce(ele, handleOnClick) {
  const [isClickedOnce, setIsClickedOnce] = useState(false);

  const onHandleClickOnce = useCallback(() => {
    if (!isClickedOnce) {
      setIsClickedOnce(true);
      handleOnClick();
    }
  }, [handleOnClick, isClickedOnce]);

  useElementEvent(ele, 'click', onHandleClickOnce);
}
